export var ACTION;
(function (ACTION) {
    ACTION["TRACK"] = "TRACK";
    ACTION["MANAGE"] = "MANAGE";
    ACTION["CTA"] = "CTA";
    ACTION["GO_BACKAction"] = "GO_BACKAction";
    ACTION["RESUME"] = "RESUME";
    ACTION["SHARE"] = "SHARE";
})(ACTION || (ACTION = {}));
